import React from "react";
import usePagination from "hooks/usePagination";
import { DOTS } from "utils/constants";
import { ReactComponent as Arrow } from "assets/svgs/small-right-arrow.svg";
import clsx from "clsx/lite";

const Pagination = ({
	onPageChange, afterPageChange,
	totalCount, siblingCount = 1,
	currentPage, pageSize,
}) => {

	const paginationRange = usePagination({
		currentPage, totalCount, siblingCount, pageSize
	});

	if (currentPage === 0 || paginationRange.length < 2)
		return <></>;


	const changeUrl = (page) => {
		const url = new URL(window.location);
		if (page === 1) url.searchParams.delete("page");
		else url.searchParams.set("page", page);
		window.history.pushState({}, "", url);
	};

	const changePage = (pageNumber) => {
		onPageChange(pageNumber);
		changeUrl(pageNumber);
		window?.scrollTo({ top: 0 });
		afterPageChange && afterPageChange();
	};

	const onNext = () => {
		if (lastPage === currentPage) return;
		changePage(currentPage + 1);
	};

	const onPrevious = () => {
		if (currentPage === 1) return;
		changePage(currentPage - 1);
	};

	const lastPage = paginationRange[paginationRange.length - 1];

	return (
		<div className="flex justify-center mt-10 md:mt-20 flex-wrap">
			<span className={clsx("pagination-item px-2 sm:px-3", currentPage === 1 && "!cursor-not-allowed text-secondary")}
				onClick={onPrevious}><Arrow className="rotate-180" /></span>
			{paginationRange.map((pageNumber, index) => pageNumber === DOTS ?
				<span key={`p-${index}`} className="pagination-item size-5">&#8230;</span> :
				<span
					key={index}
					className={clsx("pagination-item px-3 size-10 sm:mx-1", pageNumber === currentPage && "bg-beige")}
					onClick={() => changePage(pageNumber)}>
					{pageNumber}
				</span>
			)}
			<span
				className={
					clsx("pagination-item size-10 px-2 sm:px-3",
						lastPage === currentPage && "!cursor-not-allowed text-secondary")}
				onClick={onNext}><Arrow /></span>
		</div>
	);
};

export default Pagination;
